import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'
import { PageHeader, StoreOnly } from '@/ui/shared'
import { IntegrationsList } from '../integrations-list'
import InstalledIntegrations from '../installed-integrations'

const { TabsRoot, TabsList, Tab, TabsIndicator, TabPanel } = Base

// The app store's carriers, as they are: a request posts the form to Slack and ops set the carrier up per portal.
export const CARRIERS = 'Shipping'

export default function CarriersSection() {
  const { t } = useTranslation()
  return (
    <>
      <PageHeader
        title={t('integrations_hub.carriers.title')}
        description={t('integrations_hub.carriers.description')}
      />
      <StoreOnly>
        <div className="max-w-screen-xl px-7 py-4">
          <TabsRoot defaultValue="explore">
            <TabsList>
              <Tab value="explore">{t('integrations_store.explore_tab')}</Tab>
              <Tab value="installed">
                {t('integrations_store.installed_tab')}
              </Tab>
              <TabsIndicator />
            </TabsList>
            <TabPanel value="explore">
              <IntegrationsList category={CARRIERS} searchQuery="" />
            </TabPanel>
            <TabPanel value="installed">
              <InstalledIntegrations category={CARRIERS} searchQuery="" />
            </TabPanel>
          </TabsRoot>
        </div>
      </StoreOnly>
    </>
  )
}
